import React, { ButtonHTMLAttributes } from "react";

export interface FabBtnProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "style"> {
  color?: "dark" | "light";
}

const getFabTailwind = (color: string) => {
  if (color === "dark") {
    return "bg-[#212121] text-white shadow-[0px_6px_12px_-6px_rgba(0,0,0,0.12),0px_8px_24px_-4px_rgba(0,0,0,0.08)]";
  }
  if (color === "light") {
    return "bg-white border border-[#eeeeee] text-[#212121] shadow-[0px_6px_12px_-6px_rgba(0,0,0,0.12),0px_8px_24px_-4px_rgba(0,0,0,0.08)]";
  }
  return "bg-[#212121] text-white";
};

const Fab: React.FC<FabBtnProps> = ({
  color = "dark",
  disabled = false,
  ...props
}) => {
  const base =
    "flex items-center justify-center w-[40px] h-[40px] rounded-[40px] transition-all duration-200";
  const tw = getFabTailwind(color);

  return (
    <button
      className={`${base} ${tw}`}
      disabled={disabled}
      type="button"
      {...props}
    />
  );
};

export default Fab;
